<ticker-card
  titleText="Opportunities"
  [data]="data"
  [percentage]="20.3"
  icon="datatrending"
></ticker-card>
